import axios from "axios";

import { toast } from "react-toastify";
import { Urls, mainUrl } from "../apiUrls/apiUrl";
export const AUTENTICATE_API = {
  customerLogin,
};

// function customerLogin(requestOptions) {
//   return axios
//     .post(Urls + "user_login", requestOptions)
//     .then((response) => {
//       return response.data;
//     })
//     .catch((error) => {
//       if (error == "Unauthorized") {
//         return [];
//       }
//       if (error.response != undefined)
//         if (error.response.status === 401) {
//           toast.error("User nicht gefunden ");
//         } else if (error.response.status === 400) {
//           toast.error(error?.response?.data?.message);
//         } else if (error.response.status === 409) {
//           toast.error(error?.response?.data?.message);
//         } else if (error.response.status === 404) {
//           toast.error(error?.response?.data?.message);
//         } else if (error.response.status === 500) {
//           toast.error(error?.response?.data?.message);
//         }
//     });
// }

function customerLogin(requestOptions) {
  const urlEncodedData = new URLSearchParams();
  for (const key in requestOptions) {
    urlEncodedData.append(key, requestOptions[key]);
  }

  return axios
    .post(mainUrl + "user_login", urlEncodedData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error Response:", error.response);

      if (error == "Unauthorized") {
        return [];
      }

      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.error || "An unexpected error occurred.";

        if (status === 401) {
          toast.error("Unauthorized access", { autoClose: 2500 });
        } else {
          toast.error(message, { autoClose: 2500 });
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.", {
          autoClose: 2500,
        });
      }
    });
}
